import { Box, Grid, Link, Typography } from '@mui/material'
import React from 'react'
import LoginImage from '../../image/login_background.png'
import LogoImage from '../../image/logo_dark.png'
import LoginForm from '../login-form/LoginFormContainer'
import {
    Logo,
    Image,
    GridContainer,
    GridLeft,
    LogoContainer,
    FormContainer,
} from './LoginPage.styled'
import messages from './LoginPage.messages'
import { FormattedMessage, useIntl } from 'react-intl'

export interface IOwnProps {}

export interface IStateProps {
    isLogged: boolean
}

export interface IDispatchProps {}

export type IProps = IOwnProps & IStateProps & IDispatchProps

const LoginPage: React.FC<IProps> = (props) => {
    const { isLogged } = props

    const intl = useIntl()

    if (isLogged) {
        return null
    }

    return (
        <GridContainer container>
            <GridLeft item xs={6}>
                <LogoContainer>
                    <Logo
                        src={LogoImage}
                        alt={intl.formatMessage({ ...messages.logo })}
                    />
                </LogoContainer>

                <Box>
                    <Box mb={14}>
                        <Typography align='center' variant='h5'>
                            <FormattedMessage {...messages.title} />
                        </Typography>
                    </Box>

                    <FormContainer>
                        <LoginForm />
                    </FormContainer>
                </Box>

                <Box pb={'15px'} textAlign='center'>
                    {/* <Link
                        color='#7d7d7d'
                        fontSize='14px'
                        href={process.env.REACT_APP_EXTERNAL_LINK || '/'}
                    >
                        {messages.enterApiKey.defaultMessage}
                    </Link> */}
                </Box>
            </GridLeft>

            <Grid item xs={6}>
                <Image
                    src={LoginImage}
                    alt={intl.formatMessage({ ...messages.loginPage })}
                />
            </Grid>
        </GridContainer>
    )
}

export default LoginPage
